
import React, { Component } from "react";
import {Button ,Well,ButtonGroup,Glyphicon,ToggleButtonGroup,ToggleButton,ControlLabel,FormGroup,FormControl,HelpBlock,InputGroup,Label} from "react-bootstrap";

function pad(n, width, z) {
  z = z || '0';
  n = n + '';
  return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
}




function dayString(wdays){
//  console.log("Day String")
  let i=0
  const days_abv=["mon","tue","wed","thu","fri","sat","sun"]
  const days_full=["Monday","Tuesday","Wednesday","Thursday","Friday","Saturday","Sunday"]
  if(wdays.includes("mon") && wdays.includes("tue") && wdays.includes("wed") && wdays.includes("thu") && wdays.includes("fri") && wdays.length==5)
    return "Every day Monday-Friday "
  if(wdays.includes("sat") && wdays.includes("sun") && wdays.length==2)
    return "Every Saturday & Sunday "
  if(wdays.length>=5){
    //say the days we dont run
    let exceptdays=[]
    for(i=0;i<days_abv.length;i++){
    //  console.log(days_abv[i])
      if(wdays.includes(days_abv[i])==false){
          exceptdays.push(days_full[i])
      }
    }
    if(exceptdays.length>1){
      exceptdays=exceptdays.join(' & ')
    }
    else{
      exceptdays=exceptdays[0]
    }
    return "Every day except "+exceptdays+" "
  }else{
    let tempStr="Every"

    for(i=0;i<wdays.length;i++){

      tempStr+=" "+days_full[days_abv.indexOf(wdays[i])]
      if(i!=wdays.length-1){
        if(i==wdays.length-2)
          tempStr+=" &"
        else
        tempStr+=","
      }
    }
    return tempStr
  }
  return "Unknown"
}


function InfoString(props){
  let d=props.data
  //console.log("InfoString")
//  console.log(d)
  //console.log(props)
  //if(!("days" in d)){

//  }
  let wday_str="Every "
  let timesplit=""
  let unit="day"
  let unit_value=1
  if(d.days>=1){
    unit="day"

    unit_value=d.days
  }
  else if(d.hours>=1){
    unit="hour"
    unit_value=d.hours
  }
  else if(d.mins>=1){
    unit="min"
    unit_value=d.mins
  }
  else if(d.secs>=1){
    unit="sec"
    unit_value=d.secs
  }


  let at_str=(<span>@ {pad(d.hours,2)}:{pad(d.mins,2)}</span>)
  if(unit=="hour"){
    at_str=(<span>@ :{pad(d.mins,2)} minutes past</span>)
    if(d.mins==0){
      at_str= " on the hour"
    }
  }
  if(unit=="min" || unit=="sec"){
    at_str=""
  }
  if(unit=="day" && unit_value<=1){
    if("wdays" in d){
    if(d.wdays.includes("every"))
      wday_str="Every day "
    else
      wday_str=dayString(d.wdays)
    }
  }
  else{
  let duration_sec=0
  switch(unit){
    case "day":
      duration_sec=unit_value*(3600*24)
      break;
    case "hour":
      duration_sec=unit_value*3600
      break;
    case "min":
      duration_sec=unit_value*60
      break;
    case "sec":
      duration_sec=unit_value
      break;
  }
  timesplit=formatTime(duration_sec)
}
  let disabled_label=""
  if(d.enabled==false){
    disabled_label=<Label className={"level3"}>Disabled!</Label>
  }

  return (<i>{wday_str} {timesplit} {at_str} {disabled_label}</i>)
}



function formatTime(seconds) {
  const d = Math.floor(seconds / (3600*24));
  const h = Math.floor((seconds %(3600*24))/ 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = seconds % 60;
  let timestr=""
  if(d>0){
    timestr=d+ " day"
  }
  //Add the plural
  if(d>1)
    timestr+="s "

  if(h>0){
    timestr+=" "+h+ " hour"
  }
    //Add the plural
  if(h>1)
    timestr+="s "

  if(m>0){
    timestr+=" "+m+ " minute"
  }
    //Add the plural
  if(m>1)
    timestr+="s "

  if(s>0){
    timestr+=" "+s+ " second"
  }
      //Add the plural
  if(s>1)
    timestr+="s "





  return timestr


}

function TimeString(props){

//  console.log(props.data)

  let days=[]
/*  if( props.data.wdays.includes("every")){
    days.push((<Label bsStyle="info">Every Day</Label>))
  }*/

  if( props.data.wdays.includes("mon")){
    days.push((<Label bsStyle="info">Monday</Label>))
  }
  if( props.data.wdays.includes("tue")){
    days.push((<Label bsStyle="info">Tuesday</Label>))
  }
  if( props.data.wdays.includes("wed")){
    days.push((<Label bsStyle="info">Wednesday</Label>))
  }
  if( props.data.wdays.includes("thu")){
    days.push((<Label bsStyle="info">Thursday</Label>))
  }
  if( props.data.wdays.includes("fri")){
    days.push((<Label bsStyle="info">Friday</Label>))
  }

  if( props.data.wdays.includes("sat")){
    days.push((<Label bsStyle="info">Saturday</Label>))
  }
  if( props.data.wdays.includes("sun")){
    days.push((<Label bsStyle="info">Sunday</Label>))
  }

  let hours=pad(props.data.hours,2)
  let mins=pad(props.data.mins,2)
  let secs=pad(props.data.secs,2)

  let timestr=""


  //Interval

  if(props.data.setStart==false){
      if(props.data.hours!=0){
          timestr="Every "+hours+"h"+mins+"m"+ secs+"s"
      }else{
        if(props.data.mins!=0){
          timestr="Every "+mins+"m"+ secs+"s"
        }
        else{
          timestr="Every "+secs+"s"
        }
      }
  }





  return (<span>{timestr}&nbsp;{days.map((e)=><span>{e}</span>)}</span>)


}



export default class ScheduleItem extends Component {
    constructor(props) {
      super(props);
      this.state = {
        initialName:props.data.name,
        initialAddr:parseInt(props.data.address),
        initialChn:parseInt(props.data.channel),
        rgbAlert:props.data.alertLed,
        outEdit:false
      };

    }

  componentWillMount() {

  }

  toggleAlert=()=>{

  //  console.log("Alert Toggle")

  }

editOutName=()=>{
    this.setState({outEdit:true})
}
saveOutputName=()=>{
//  console.log(this.state.initialName)

  let data=this.props.data
  data["name"]=this.state.initialName
  data["channel"]=parseInt(this.state.initialChn)
  data["address"]=parseInt(this.state.initialAddr)



  if("alertLed" in data){
    data["alertLed"]=this.state.rgbAlert
  }
  this.props.callback({
    cmd:"output",
    type:"update",
    data:data
  })
  this.setState({outEdit:false})
}

deleteOutput=()=>{
  let data=this.props.data
  this.props.callback({
    cmd:"output",
    type:"delete",
    data:data
  })
  this.setState({outEdit:false})



}

showHelp=()=>{
  this.props.callback({
    cmd:"output",
    type:"helpRF",
  })

}


closeOutputName=()=>{
this.setState({outEdit:false})

}

changeSetting=(e)=>{
  console.log(e.target.value)
  console.log(e.target.name)

  let update={}
  update[e.target.name]=e.target.value
  this.setState(update)
  console.log(update)
}

changeName=(e)=>{
  this.setState({initialName:e.target.value})

}



    render(){
      //console.log(this.props)




      return (<Well bsSize="small">
        <span><h4>{this.props.data.name}</h4>

<InfoString data={this.props.data} ></InfoString>
        </span>



        <Button className="pull-right "  bsSize="xsmall" onClick={()=>this.props.callback(this.props,"edit")}>Edit</Button>
        <Button className="pull-right "  bsSize="xsmall" onClick={()=>this.props.callback(this.props,"delete")}>Delete</Button>
        {this.props.data.enabled==true ? (
            <Button className="pull-right "  bsSize="xsmall" onClick={()=>this.props.callback(this.props,"disable")}>Disable</Button>

        ):(  <Button className="pull-right "  bsSize="xsmall" onClick={()=>this.props.callback(this.props,"enable")}>Enable</Button>)

      }
      </Well>)


    }
}




/*
{/*  <input value={this.state.initialName} onChange={this.changeName}></input>


  {this.props.data.ctrlType=="RF_SOCKET" ?(<div>

  GROUP 0-255<input type="number"    min={0} max={255}   value={this.state.initialAddr} name="initialAddr" onChange={this.changeSetting} ></input>
  CHANNEL 0-255<input type="number"  min={0} max={255}   value={this.state.initialChn}  name="initialChn"  onChange={this.changeSetting} ></input>


    </div>
    ):("")}

    {this.props.data.ctrlType=="RELAY PACK" ?(<div>
    ADDRESS 0-256<input type="number"    min={0} max={256}   value={this.state.initialAddr} name="initialAddr" onChange={this.changeSetting} ></input>
    CHANNEL 0-8<input type="number"  min={0} max={8}   value={this.state.initialChn}  name="initialChn"  onChange={this.changeSetting} ></input>
      </div>
      ):("")}


  <Button onClick={()=>this.saveOutputName()}>Done</Button><Button onClick={()=>this.closeOutputName()}>Cancel</Button>
  <Button onClick={()=>this.deleteOutput()}>Delete</Button>
{this.props.data.ctrlType=="RF_SOCKET" ?(
<div className="pull-right">
<Button onClick={()=>this.showHelp()}>Help</Button>
</div>):(<span></span>)}
  {this.props.data.ctrlType=="RGB STRIP" ?(<div className="pull-right">
      {this.state.rgbAlert ? (<span onClick={()=>this.toggleAlert()}>Alert Mode Enabled</span>):(<span onClick={()=>this.toggleAlert()}>Alert Mode Disabled</span>)}
    </div>
    ):("")}
  </div>
):(
  <div>
  <h4>{this.props.data.name}&nbsp;<Glyphicon onClick={()=>this.editOutName()} title="Edit name" className="iconBut" glyph="pencil" />
  <OutControls data={this.props.data} callback={this.props.callback}/></h4>
  */



// WEBPACK FOOTER //
// ./src/programmerComponents/ScheduleItem.js